// @flow
import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from './styles';
import messages from './messages';

type Props = {
  sources: Array<Object>,
  isEmpty: boolean,
};

export default function SourcesList({ sources, isEmpty }: Props): React.Node {
  if (isEmpty) {
    return null;
  }

  return (
    <div className="sources-wrapper">
      <p>
        <FormattedMessage {...messages.sourceSlogan} />
      </p>
      <div className="images-wrapper">
        {sources.map((source: Object) => (
          <img key={source.name} src={source.image} alt={source.name} />
        ))}
      </div>
      <style jsx>{styles}</style>
    </div>
  );
}



// WEBPACK FOOTER //
// ./app/Sources/list/components/SourcesList/index.js